import script from "./RiskNoticeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RiskNoticeModal.vue?vue&type=script&setup=true&lang=js"

import "./RiskNoticeModal.vue?vue&type=style&index=0&id=ae54e3c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae54e3c2"]])

export default __exports__